import { Form } from '@roo/roo';
import React, { useRef } from 'react';
import { isEqual } from 'lodash';
import { useSimpleContext } from '../_context';

export function FormHok(props) {
  const {
    onChange, handleSave, children, ...rest
  } = props;
  const { update, state } = useSimpleContext((t) => [
    t.hasSubmit,
    t.disabled,
    t.innovate,
    t.scientist,
  ]);
  update((t) => {
    t.handleSave = handleSave;
  }, true);

  return (
    <Form
      {...rest}
      disabled={state.disabled}
      onChange={(name, value, values) => {
        update((t) => {
          t.values = values;
          t.hasSave = false;
          t.hasChange = true;
        });

        if (props.onChange) {
          props.onChange(name, value, values);
        }
      }}
      alwaysUpdate
    >
      {(props) => <FormChild {...props}>{children(props)}</FormChild>}
    </Form>
  );
}

function FormChild(props) {
  const { update, state } = useSimpleContext((t) => [t.values]);
  const ref = useRef(true);
  if (ref.current && !isEqual(state.values, props.values)) {
    // ref.current;
    update((t) => {
      t.values = props.values;
    }, true);
  }

  update((s) => {
    s.validateFields = props.validateForm;
  }, true);
  return props.children;
}
